<app-spinner *ngIf="isProcessing" [message]="'Recuperando respuesta...'" class="fadeIn animated"></app-spinner>

<app-message
    *ngIf="isUnHandleError"
    [message]="'Hubo un error procesando la respuesta del pago'"
    [subMessage]="
        'No se pudo procesar la verificación del pago. Comuníquese con el equipo de TI para reportar el error.'
    "
    [icon]="'warning'"
    class="fadeIn animated"
>
    <div class="tw-text-center tw-mt-4">
        <button class="uk-button" routerLink="/state">Regresa a mi estado de pagos</button>
    </div>
</app-message>

<ng-container *ngIf="hasNiubizResponse">
    <div class="tw-flex tw-flex-wrap tw--mx-2 fadeIn animated">
        <div class="tw-w-full md:tw-w-2/3 tw-px-2">
            <div class="club-socio-panel">
                <div class="uk-clearfix mb-1">
                    <a class="uk-button tw-mr-2 tw-inline-block" routerLink="/">
                        <i class="uk-icon uk-icon-home"></i> Regresar al Inicio
                    </a>
                    <button class="uk-button" roNgxSimplePrint [printContentId]="'printed-section'">
                        <i class="uk-icon uk-icon-print"></i> Imprimir
                    </button>
                </div>
                <app-payment-visa-response-success
                    *ngIf="isSuccessResponse"
                    [dataResponse]="paymentResponse"
                ></app-payment-visa-response-success>
                <app-payment-visa-response-error
                    *ngIf="!isSuccessResponse"
                    [dataResponse]="paymentResponse"
                ></app-payment-visa-response-error>
            </div>
        </div>
        <div class="tw-w-full md:tw-w-1/3 tw-px-2">
            <app-payment-recomendations></app-payment-recomendations>
        </div>
    </div>
</ng-container>
